module.exports = __webpack_public_path__ + "static/media/forklift_sel.194f715f.svg";